//import { atob } from 'buffer';
import {
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_RESET,
  ORDER_CREATE_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_MINE_LIST_FAIL,
  ORDER_MINE_LIST_REQUEST,
  ORDER_MINE_LIST_SUCCESS,
  QUOTE_REQUEST_FAIL,
  QUOTE_REQUEST_START,
  QUOTE_REQUEST_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_PAY_REQUEST,
  ORDER_PAY_RESET,
  ORDER_PAY_SUCCESS,
} from '../constant/orderConstant';
//import { execFile } from 'child_process';

interface OrderCreateState { loading?: boolean; success?: boolean; order?: any; error?: string; }

export function orderCreateReducer(state: OrderCreateState = {}, action: any) {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
      return { loading: true };

    case ORDER_CREATE_SUCCESS:
      return { loading: false, success: true, order: action.payload };

    case ORDER_CREATE_FAIL:
      return { loading: false, error: action.payload };

    case ORDER_CREATE_RESET:
      return {};
    default:
      return state;
  }
}

interface OrderDetailsState { loading?: boolean; success?: boolean; order?: any; error?: string; }

export function orderDetailsReducer(
  state: OrderDetailsState = { loading: true, order: {} },
  action: any
) {
  switch (action.type) {
    case ORDER_DETAILS_REQUEST:
      return { loading: true };

    case ORDER_DETAILS_SUCCESS:
      return { loading: false, success: true, order: action.payload };

    case ORDER_DETAILS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
}

interface QuoteState { loading?: boolean; success?: boolean; message?: string; }

export function quoteReducer(
  state: QuoteState = { loading: false, success: false, message: ' ' },
  action: any
) {
  switch (action.type) {
    case QUOTE_REQUEST_START:
      return { ...state, loading: true, success: false, message: ' ' };

    case QUOTE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        message: action.payload,
      };

    case QUOTE_REQUEST_FAIL:
      return { loading: false, success: false, message: action.payload };

    default:
      return state;
  }
}

interface OrderPayState { loading?: boolean; success?: boolean; order?: any; error?: string; }

export const orderPayReducer = (state: OrderPayState = {}, action: any) => {
  switch (action.type) {
    case ORDER_PAY_REQUEST:
      return { loading: true };

    case ORDER_PAY_SUCCESS:
      return { loading: false, success: true, order: action.payload };

    case ORDER_PAY_FAIL:
      return { loading: false, error: action.payload };

    case ORDER_PAY_RESET:
      return {};

    default:
      return state;
  }
};

interface OrderMineListState { loading?: boolean; orders?: any[]; error?: string; }

export const orderMineListReducer = (state: OrderMineListState = { orders: [] }, action: any) => {
  switch (action.type) {
    case ORDER_MINE_LIST_REQUEST:
      return { loading: true };
    case ORDER_MINE_LIST_SUCCESS:
      return { loading: false, orders: action.payload };
    case ORDER_MINE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
